var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1434 9.21289H11.9025L11.9023 23.361H20.1432L20.1434 9.21289Z",
    fill: "#C4C7CF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9998 0C7.16295 0 0 7.16376 0 16.0003C0 24.8363 7.16337 32.0001 15.9998 32.0001C24.8359 32.0001 32 24.8363 32 16.0003C32 7.16376 24.8359 0 15.9998 0ZM22.3064 23.3759C22.3064 24.9969 18.9921 25.8993 15.9199 25.8993C12.848 25.8993 9.73954 24.9969 9.73954 23.3759V8.43929C9.73954 6.81794 12.848 5.91557 15.9199 5.91557C18.9918 5.91557 22.3064 6.81794 22.3064 8.43929V23.3759Z",
    fill: "#C4C7CF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.4efad2365a6f605ba2ce0bd1e2a36556.svg";
export { ForwardRef as ReactComponent };